module.exports = __webpack_public_path__ + "img/florina-2021-white.dc4e612d.png";